// extracted by mini-css-extract-plugin
export default {"headerBlock":"styles_headerBlock__EpDZT","logout":"styles_logout__edZZN"};